export {NetWorthView} from 'src/NetWorthView/NetWorthView';
